module.exports = __webpack_public_path__ + "static/img/img-5-3.4065339.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-5-3.png
// module id = 7Jrv
// module chunks = 0